import styled from 'styled-components';

export const Header = styled.header`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: 99px;
    color: #FFF;
    background-color: #254D6B;

    ul {
        display: flex;
        width: 45%;
        list-style-type: none;

        li {
            margin-right: 25px;
        }
    }
`;

export const Logo = styled.div``;

export const CtaSubscribe = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 330px;
    height: 48px;
    color: #888;
    border-radius: 32px;
    background-color: #FFF;

    span {
        margin-left: 20px;
    }

    button {
        color: #FFF;
        border:0;
        height: 100%;
        border-radius: 32px;
        padding:10px 20px;
        background-color: #27AE60;
    }
`;

export const Footer = styled.footer`
  background: #1a3a52;
  color: #ffffff;
  padding: 1rem 0 1rem;
  margin-top: auto;
  width: 100%;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    padding: 1.25rem 0 0.75rem;
  }
`;

export const FooterContainer = styled.div`
  max-width: 760px;
  margin: 0 auto;
  padding: 0 1rem;

  @media screen and (max-width: 768px) {
    padding: 0 0.75rem;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 0.75rem;
  }
`;

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FooterTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 1.125rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 1rem;
  letter-spacing: 0.025em;
`;

export const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FooterLink = styled.li`
  a {
    font-family: 'Inter', sans-serif;
    font-size: 0.9375rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    display: inline-block;

    &:hover {
      color: #27ae60;
      transform: translateX(4px);
    }
  }
`;

export const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ContactItem = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.2;

  a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: #27ae60;
    }
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  color: #ffffff;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: #27ae60;
    transform: translateY(-1px);
  }

  @media screen and (max-width: 768px) {
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }
`;

export const FooterBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.35rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;
    padding-top: 0.3rem;
  }
`;

export const Copyright = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  margin: 0;

  a {
    color: #27ae60;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: #3bc775;
      text-decoration: underline;
    }
  }
`;